document.addEventListener("DOMContentLoaded", function () {
  var fix_dom_visible = false;
    $(".faq_tag a").on("click", function () {
      var select_text = $.trim($(this).text().toLowerCase());
      var faqs = $("#MainContent").find(".t4s-accordion");
  
      $(this).addClass("on").siblings("a").removeClass("on");
  
      for (var i = 0; i <= faqs.length; i++) {
        var _this = $(faqs[i]);
        var title = $.trim(
          _this.find(".t4s-section-title").text().toLowerCase()
        );
        if (title === select_text) {
          $("html").animate(
            {
              scrollTop: _this.offset().top - 80,
            },
            300
          );
        }
      }
    });
  
    function calcFixed() {
      var fix_dom = $(".accrdin_contact");
      if (!fix_dom.length) return false;
      if(!fix_dom_visible){
        fix_dom.show();
        fix_dom_visible = true
      }
      var first_faq = $("#MainContent").find(".t4s-accordion").first();
      var last_faq = $("#MainContent").find(".t4s-accordion").last();
      var top = first_faq.offset().top;
      var bottom = last_faq.offset().top + last_faq.height();
      var scroll_top = $(window).scrollTop() + 30;
      if (scroll_top > top && scroll_top < bottom - 350) {
        fix_dom.attr("style", "top: 80px");
      } else if (scroll_top < top) {
        fix_dom.attr("style", "top: " + (top - scroll_top + 80) + "px");
      } else if (scroll_top > bottom - 350) {
        fix_dom.attr("style", "top: " + (bottom - scroll_top - 350) + "px");
      }
    }
    try {
        calcFixed();
        $(window).on("resize", calcFixed);
        $(window).on("scroll", calcFixed);
    } catch (e) {
        console.error(e);
    }
  
    $("#faq-name").on("keyup", function (e) {
      if (e.keyCode === 13) {
        searchFaq();
      }
    });
    $(".faq-button").on("click", searchFaq);
  
    function searchFaq() {
      var faqs = $("#MainContent").find(".t4s-tab-wrapper").removeClass("t4s-active");
      var search_str = $("#faq-name").val().toLowerCase();
      console.log("q", search_str);
      if (!search_str) return;
      for (var i = 1; i <= faqs.length; i++) {
        var _this = $(faqs[i]);
        var title = _this.find(".t4s-accor-title .t4s-accor-text").text().toLowerCase();
        var content = _this.find(".t4s-tab-content").text().toLowerCase();
  
        if (title.match(search_str) || content.match(search_str)) {
            _this.find(".t4s-accor-title").trigger("click");
          $("html").animate(
            {
              scrollTop: _this.offset().top - 80,
            },
            300
          );
  
          break;
        }
      }
    }
  });
  